import { BASE_URL, BASE_URL_ML } from "@/store/urls";
export const auth_base_url = BASE_URL + "user/auth/";
export const user_base_url = BASE_URL + "user/";
export const public_base_url = BASE_URL + "public/";
export const candidate_base_url = BASE_URL + "candidate/";
export const recruiter_base_url = BASE_URL + "recruiter/";
export const zappyhire_base_url = recruiter_base_url + "zappy/";
export const assessment_base_ml_url = BASE_URL_ML + "assessments/";
export const edit_assessment_base_ml_url = BASE_URL_ML + "edit-assessment/";
